import script from "./MakeProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./MakeProgress.vue?vue&type=script&setup=true&lang=js"

import "./MakeProgress.vue?vue&type=style&index=0&id=34730fdb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34730fdb"]])

export default __exports__